import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import { getTrip } from "redux/actions/UserTrip";
import store from "redux/store";
import { GET_ASSIGN_DRIVER_FAILED, GET_ASSIGN_DRIVER_REQUESTED, GET_ASSIGN_DRIVER_SUCCESS, GET_CANCEL_TRIP_FAILED, GET_CANCEL_TRIP_REQUESTED, GET_CANCEL_TRIP_SUCCESS, GET_INVOICE_DOWNLOAD_FAILED, GET_INVOICE_DOWNLOAD_REQUESTED, GET_INVOICE_DOWNLOAD_SUCCESS, GET_INVOICE_FAILED, GET_INVOICE_REQUESTED, GET_INVOICE_SUCCESS, GET_SOS_ALERT_FAILED, GET_SOS_ALERT_REQUESTED, GET_SOS_ALERT_SUCCESS, GET_TRIP_FAILED, GET_TRIP_REQUESTED, GET_TRIP_SUCCESS, GET_SHARE_TRIP_SUCCESS, GET_SHARE_TRIP_FAILED, GET_SHARE_TRIP_REQUESTED } from "resources/actionTypes";
import { assignDriverApi, cancelTripApi, invoiceApi, invoiceDownloadApi, sosApi, tripApi, shareTripApi } from "services/TripService";

function* fetchTrip(action) {
  try {
    const payload = action.payload || {}
    const userTrip = yield call(tripApi,payload);
    yield put({ type: GET_TRIP_SUCCESS, userTrip: userTrip });
  } catch (e) {
    yield put({ type: GET_TRIP_FAILED, message: e.message });
    toast.error(e.message || 'Get Trip Failed')
  }
}

export function* tripSaga() {
  yield takeEvery(GET_TRIP_REQUESTED, fetchTrip);
}

function* fetchSosAlert(action) {
  try{
    const payload = action.payload || {}
    const userSOSAlert = yield call(sosApi,payload);
    yield put({type:GET_SOS_ALERT_SUCCESS, userSOSAlert:userSOSAlert}); 
  } catch(e) {
    yield put({ type:GET_SOS_ALERT_FAILED, message: e.message });
    toast.error(e.message || 'Get Sos Alert Failed')

  }
}

export function* sosAlertSaga() {
  yield takeEvery(GET_SOS_ALERT_REQUESTED,fetchSosAlert);
}

function* fetchCancelTrip(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userCancelTrip = yield call(cancelTripApi, payload);
  if(userCancelTrip.success){
    yield put({ type: GET_CANCEL_TRIP_SUCCESS, userCancelTrip: userCancelTrip });
    toast.success(userCancelTrip.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getTrip(payload));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_CANCEL_TRIP_FAILED, message: userCancelTrip.message });
      toast.error(userCancelTrip.message || 'Cancellation failed');
  }
}

export function* cancelTripSaga() {
  yield takeEvery(GET_CANCEL_TRIP_REQUESTED, fetchCancelTrip);
}

function* fetchAssignDriver(action) {
  try {
    const payload = action.payload || {}
    const userAssignDriver = yield call(assignDriverApi,payload);
    yield put({ type: GET_ASSIGN_DRIVER_SUCCESS, userAssignDriver: userAssignDriver });
  } catch (e) {
    yield put({ type: GET_ASSIGN_DRIVER_FAILED, message: e.message });
    toast.error(e.message || 'Get Assign Driver Failed')
  }
}

export function* assignDriverSaga() {
  yield takeEvery(GET_ASSIGN_DRIVER_REQUESTED, fetchAssignDriver);
}

function* fetchInvoice(action) {
  try {
    const payload = action.payload || {}
    const userInvoice = yield call(invoiceApi, payload);
    
    // Check if the response indicates an error
    if (!userInvoice.success) {
      yield put({ type: GET_INVOICE_FAILED, message: userInvoice.message });
      toast.error(userInvoice.message || 'Get Invoice Failed');
      return;
    }
    
    yield put({ type: GET_INVOICE_SUCCESS, userInvoice: userInvoice });
  } catch (e) {
    yield put({ type: GET_INVOICE_FAILED, message: e.message });
    toast.error(e.message || 'Get Invoice Failed')
  }
}

export function* invoiceSaga() {
  yield takeEvery(GET_INVOICE_REQUESTED, fetchInvoice);
}

function* fetchInvoiceDownload(action) {
  try {
    const payload = action.payload || {}
    const userInvoiceDownload = yield call(invoiceDownloadApi,payload);
    if(userInvoiceDownload?.success){
      window.open(userInvoiceDownload?.data?.name?.url);
    }
    yield put({ type: GET_INVOICE_DOWNLOAD_SUCCESS, userInvoiceDownload: userInvoiceDownload });
  } catch (e) {
    yield put({ type: GET_INVOICE_DOWNLOAD_FAILED, message: e.message });
    toast.error(e.message || 'Get Invoice Download Failed')
  }
}

export function* invoiceDownloadSaga() {
  yield takeEvery(GET_INVOICE_DOWNLOAD_REQUESTED, fetchInvoiceDownload);
}

//migrated ShareTrip Saga
function* fetchShareTrip(action){
  try{
    const payload = action.payload || {}
    const userShareTrip = yield call(shareTripApi, payload);
    yield put({type: GET_SHARE_TRIP_SUCCESS, userShareTrip:userShareTrip});
  } catch(e) {
    yield put({type:GET_SHARE_TRIP_FAILED, message:e.message})
  }
  }
 export function* shareTripSaga() {
  yield takeEvery(GET_SHARE_TRIP_REQUESTED, fetchShareTrip);
 }